import { Component, OnInit, Input, ChangeDetectorRef, AfterViewInit, AfterViewChecked } from '@angular/core';
import { EventService } from '../../services/event/event.service';
import { EmbedVideoService } from 'ngx-embed-video';
import { DomSanitizer } from '@angular/platform-browser';
import { HelperService } from '../../services/helper/helper.service';

declare var $;

@Component({
  selector: 'app-view-video-modal',
  templateUrl: './view-video-modal.component.html',
  styleUrls: ['./view-video-modal.component.css']
})
export class ViewVideoModalComponent implements OnInit, AfterViewInit, AfterViewChecked {

  public iframeHtml: any;
  public video = null;
  public loaded = false;
  private _setIframeOnLoadListener = false;

  constructor(
    private event: EventService,
    private embedService: EmbedVideoService,
    private sanitizer: DomSanitizer,
    private helper: HelperService,
    private cdRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.event.on('showViewVideoModal', (video) => {
      this.initVideo(video);
    });
  }

  ngAfterViewInit() {
    $('#viewVideoModal').on('hidden.bs.modal', () => {
      this.loaded = false;
      this.iframeHtml = '';
      this._setIframeOnLoadListener = true;
      this.cdRef.detectChanges();
      if ($('.modal-backdrop.in').length) {
        $('body').addClass('modal-open');
      }
    });
  }

  ngAfterViewChecked() {
    const elem = document.getElementById('video-iframe');
    if (elem && !this._setIframeOnLoadListener) {
      this._setIframeOnLoadListener = true;
      elem.onload = () => {
        this.loaded = true;
      };
    }
  }

  private initVideo(video: any) {
    this.video = video;
    if (this.video.extension) {
      const url = this.helper.getDownloadablePath(video);
      const iframe = `<iframe src="${url}" id="video-iframe" width="100%" height="300" frameborder="0" allowfullscreen></iframe>`;
      this.iframeHtml = this.sanitizer.bypassSecurityTrustHtml(iframe);
    } else {
      this.iframeHtml = this.embedService.embed(video.path, {
        query: { portrait: 0, color: '333', autoplay: 1 },
        attr: {
          width: '100%', height: 300, id: 'video-iframe', allow: 'autoplay'
        }
      });
    }
    this._setIframeOnLoadListener = false;
    // setTimeout(() => {
    //   document.getElementById('video-iframe').onload = () => {
    //     console.log('here');
    //     this.loaded = true;
    //   };
    // }, 0);
    console.log(this.video);
    console.log(this.iframeHtml);
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/view-video-modal/view-video-modal.component.ts